import allPaths from "../Config/paths"
import appointment1 from "../thirdAssets/Images/appointment1.png"
import appointment2 from "../thirdAssets/Images/appointment2.png"
import appointment3 from "../thirdAssets/Images/appointment3.png"
import homeAboutWhite1 from "../thirdAssets/Images/homeAboutWhite1.png"
import homeAboutWhite2 from "../thirdAssets/Images/homeAboutWhite2.png"
import homeAboutGreen1 from "../thirdAssets/Images/homeAboutGreen1.png"
import homeAboutGreen2 from "../thirdAssets/Images/homeAboutGreen2.png"
import homeExperience1 from "../thirdAssets/Images/home-experience-1.png"
import homeExperience2 from "../thirdAssets/Images/home-experience-2.png"
import homeExperience3 from "../thirdAssets/Images/home-experience-3.png"
import homeExperience4 from "../thirdAssets/Images/home-experience-4.png"
import serviceImg1 from "../thirdAssets/Images/serviceCard1.png"
import serviceImg2 from "../thirdAssets/Images/serviceCard2.png"
import serviceImg3 from "../thirdAssets/Images/serviceCard3.png"
import serviceImg4 from "../thirdAssets/Images/serviceCard4.png"
import serviceImg5 from "../thirdAssets/Images/serviceCard5.png"
import serviceImg6 from "../thirdAssets/Images/serviceCard6.png"
import patient1 from "../thirdAssets/Images/patient1.jpg"
import patient2 from "../thirdAssets/Images/patient2.png"
import patient3 from "../thirdAssets/Images/patient3.jpg"
import patient4 from "../thirdAssets/Images/patient4.jpg"
import blog1 from "../thirdAssets/Images/blog1.jpg"
import blog2 from "../thirdAssets/Images/blog2.jpg"
import blog3 from "../thirdAssets/Images/blog3.jpg"
import blog4 from "../thirdAssets/Images/blog4.jpg"
import doctor1 from "../thirdAssets/Images/doctor1.jpg"
import doctor2 from "../thirdAssets/Images/doctor2.jpg"
import doctor3 from "../thirdAssets/Images/doctor3.jpg"
import doctor4 from "../thirdAssets/Images/doctor4.jpg"
import doctor5 from "../thirdAssets/Images/doctor5.jpg"
import doctor6 from "../thirdAssets/Images/doctor6.jpg"

const menuItems = [
    {
        menuName: 'Home',
        menuALName: 'بيت',
        menuGLName: 'Heim',
        menuRoute: allPaths?.THIRDHOME,
    },
    {
        menuName: 'About Us',
        menuALName: 'معلومات عنا',
        menuGLName: 'Über uns',
        menuRoute: allPaths?.THIRDABOUT,
    },
    {
        menuName: 'Services',
        menuALName: 'الخدمات',
        menuGLName: 'Dienstleistungen',
        menuRoute: allPaths?.THIRDSERVICE,
    },
    {
        menuName: 'Appointment',
        menuALName: 'ميعاد',
        menuGLName: 'Termin',
        menuRoute: allPaths?.THIRDAPPOINTMENT,
    },
    {
        menuName: 'Our Team',
        menuALName: 'فريقنا',
        menuGLName: 'Unser Team',
        menuRoute: allPaths?.THIRDOURTEAM,
    },
    {
        menuName: 'Faqs',
        menuALName: 'أسئلة وأجوبة',
        menuGLName: 'Faqs',
        menuRoute: allPaths?.THIRDOURFAQS,
    },
    {
        menuName: 'Contact Us',
        menuALName: 'اتصل بنا',
        menuGLName: 'Kontaktieren Sie uns',
        menuRoute: allPaths?.THIRDOURCONTACT,
    },
    {
        menuName: 'Content Form',
        menuALName: 'نموذج المحتوى',
        menuGLName: 'Inhaltsformular',
        menuRoute: allPaths?.THIRDDESIGNCONTENTFORM,
    },
];

const appointmentData = [
    {
        icon: appointment1,
        title: 'Satisfaction Guarantee',
        glTitle: 'Zufriedenheitsgarantie',
        alTitle: 'ضمان الرضا',
        text: 'It is very important to take care of the patient, the result of the coaching process, but it happens at such a time that there is a lot of work and pain',
        glText: 'Es ist sehr wichtig, sich um den Patienten zu kümmern, das Ergebnis des Coaching-Prozesses, aber es passiert zu einem Zeitpunkt, an dem es viel Arbeit und Schmerzen gibt',
        alText: 'إنه أمر رائع للغاية، حيث أن المريض يمضي قدمًا في عمليات التدريب، ولكنه يمر بيوم واحد، وهو عمل جيد وشميرزن.'
    },
    {
        icon: appointment2,
        title: 'Awesome Technology',
        glTitle: 'Tolle Technologie',
        alTitle: 'تكنولوجيا رهيبة',
        text: 'It is very important to take care of the patient, the result of the coaching process, but it happens at such a time that there is a lot of work and pain',
        glText: 'Es ist sehr wichtig, sich um den Patienten zu kümmern, das Ergebnis des Coaching-Prozesses, aber es passiert zu einem Zeitpunkt, an dem es viel Arbeit und Schmerzen gibt',
        alText: 'إنه أمر رائع للغاية، حيث أن المريض يمضي قدمًا في عمليات التدريب، ولكنه يمر بيوم واحد، وهو عمل جيد وشميرزن.'
    },
    {
        icon: appointment3,
        title: 'Professional Dentist',
        glTitle: 'Professioneller Zahnarzt',
        alTitle: 'طبيب أسنان محترف',
        text: 'It is very important to take care of the patient, the result of the coaching process, but it happens at such a time that there is a lot of work and pain',
        glText: 'Es ist sehr wichtig, sich um den Patienten zu kümmern, das Ergebnis des Coaching-Prozesses, aber es passiert zu einem Zeitpunkt, an dem es viel Arbeit und Schmerzen gibt',
        alText: 'إنه أمر رائع للغاية، حيث أن المريض يمضي قدمًا في عمليات التدريب، ولكنه يمر بيوم واحد، وهو عمل جيد وشميرزن.'
    },
]
const homeAboutData = [
    {
        whiteImg: homeAboutGreen1,
        greenImg: homeAboutWhite1,
        title: 'Complete Dental Care',
        glTitle: 'Komplette Zahnpflege',
        alTitle: 'العناية الكاملة بالأسنان',
        text: "It is very important to take care of the patient, as a consequence of the patient's education, but at the same time, the incidence of labor causes great pain",
        glText: "Aufgrund der Aufklärung des Patienten ist es sehr wichtig, sich um den Patienten zu kümmern, aber gleichzeitig verursacht das Auftreten von Wehen große Schmerzen",
        alText: "من المهم جدًا الاهتمام بالمريضة، نتيجة لتعليم المريضة، ولكن في نفس الوقت، فإن حدوث المخاض يسبب آلامًا كبيرة"
    },
    {
        whiteImg: homeAboutWhite2,
        greenImg: homeAboutGreen2,
        title: 'Affordable Pricing',
        glTitle: 'Erschwingliche Preise',
        alTitle: 'إرشوينجليتشي بريز',
        text: "It is very important to take care of the patient, as a consequence of the patient's education, but at the same time, the incidence of labor causes great pain",
        glText: "Aufgrund der Aufklärung des Patienten ist es sehr wichtig, sich um den Patienten zu kümmern, aber gleichzeitig verursacht das Auftreten von Wehen große Schmerzen",
        alText: "من المهم جدًا الاهتمام بالمريضة، نتيجة لتعليم المريضة، ولكن في نفس الوقت، فإن حدوث المخاض يسبب آلامًا كبيرة"
    }
]
const homeExperienceData = [
    {
        icon: homeExperience1,
        title: 'Happy Patients',
        glTitle: 'Zufriedene Patienten',
        alTitle: 'المرضى السعداء',
        quantity: 1452
    },
    {
        icon: homeExperience2,
        title: 'Online Appointments',
        glTitle: 'Online-Termine',
        alTitle: 'المواعيد عبر الإنترنت',
        quantity: 342
    },
    {
        icon: homeExperience3,
        title: 'Years Of Experience',
        glTitle: 'Langjährige Erfahrung',
        alTitle: 'سنوات من الخبرة',
        quantity: 15
    },
    {
        icon: homeExperience4,
        title: 'Doctors and Staff',
        glTitle: 'Ärzte und Personal',
        alTitle: 'الأطباء والموظفين',
        quantity: 72
    },
]
const serviceCardData = [
    {
        icon: serviceImg1,
        title: 'Teeth Whitening',
        alTitle: 'تبييض الأسنان',
        glTitle: 'Zahnaufhellung',
        text: 'It is important to take care of the patient, therefore, the patient is suffering, but at the same time, it happens that there is a lot of work and pain',
        glText: 'Es ist wichtig, sich um den Patienten zu kümmern, deshalb leidet der Patient, aber gleichzeitig kommt es auch vor, dass es viel Arbeit und Schmerzen gibt',
        alText: 'من المهم الاهتمام بالمريض، لذلك يعاني المريض، ولكن في نفس الوقت يحدث أن هناك الكثير من العمل والألم',
    },
    {
        icon: serviceImg2,
        title: 'Teeth Checkup',
        alTitle: 'فحص الأسنان',
        glTitle: 'Zahnuntersuchung',
        text: 'It is important to take care of the patient, therefore, the patient is suffering, but at the same time, it happens that there is a lot of work and pain',
        glText: 'Es ist wichtig, sich um den Patienten zu kümmern, deshalb leidet der Patient, aber gleichzeitig kommt es auch vor, dass es viel Arbeit und Schmerzen gibt',
        alText: 'من المهم الاهتمام بالمريض، لذلك يعاني المريض، ولكن في نفس الوقت يحدث أن هناك الكثير من العمل والألم',
    },
    {
        icon: serviceImg3,
        title: 'Teeth Implants',
        alTitle: 'زراعة الأسنان',
        glTitle: 'Zahnimplantate',
        text: 'It is important to take care of the patient, therefore, the patient is suffering, but at the same time, it happens that there is a lot of work and pain',
        glText: 'Es ist wichtig, sich um den Patienten zu kümmern, deshalb leidet der Patient, aber gleichzeitig kommt es auch vor, dass es viel Arbeit und Schmerzen gibt',
        alText: 'من المهم الاهتمام بالمريض، لذلك يعاني المريض، ولكن في نفس الوقت يحدث أن هناك الكثير من العمل والألم',
    },
    {
        icon: serviceImg4,
        title: 'Orthodontics',
        alTitle: 'تقويم الأسنان',
        glTitle: 'Kieferorthopädie',
        text: 'It is important to take care of the patient, therefore, the patient is suffering, but at the same time, it happens that there is a lot of work and pain',
        glText: 'Es ist wichtig, sich um den Patienten zu kümmern, deshalb leidet der Patient, aber gleichzeitig kommt es auch vor, dass es viel Arbeit und Schmerzen gibt',
        alText: 'من المهم الاهتمام بالمريض، لذلك يعاني المريض، ولكن في نفس الوقت يحدث أن هناك الكثير من العمل والألم',
    },
    {
        icon: serviceImg5,
        title: 'Dental Crown',
        alTitle: 'تاج الأسنان',
        glTitle: 'Zahnkrone',
        text: 'It is important to take care of the patient, therefore, the patient is suffering, but at the same time, it happens that there is a lot of work and pain',
        glText: 'Es ist wichtig, sich um den Patienten zu kümmern, deshalb leidet der Patient, aber gleichzeitig kommt es auch vor, dass es viel Arbeit und Schmerzen gibt',
        alText: 'من المهم الاهتمام بالمريض، لذلك يعاني المريض، ولكن في نفس الوقت يحدث أن هناك الكثير من العمل والألم',
    },
    {
        icon: serviceImg6,
        title: 'Dental Filling',
        alTitle: 'حشوة الاسنان',
        glTitle: 'Zahnfüllung',
        text: 'It is important to take care of the patient, therefore, the patient is suffering, but at the same time, it happens that there is a lot of work and pain',
        glText: 'Es ist wichtig, sich um den Patienten zu kümmern, deshalb leidet der Patient, aber gleichzeitig kommt es auch vor, dass es viel Arbeit und Schmerzen gibt',
        alText: 'من المهم الاهتمام بالمريض، لذلك يعاني المريض، ولكن في نفس الوقت يحدث أن هناك الكثير من العمل والألم',
    },
]

const patientFeedBackData = [
    {
        img: patient1,
        name: 'Dwayne Lake',
        role: 'Entrepreneur',
        alName: 'دوين ليك',
        alRole: 'رائد أعمال',
        glName: 'Dwayne Lake',
        glRole: 'Unternehmer',
    },
    {
        img: patient2,
        name: 'Oliver Gomez',
        role: 'Manager',
        alName: 'أوليفر جوميز',
        alRole: 'مدير',
        glName: 'Oliver Gomez',
        glRole: 'Manager',
    },
    {
        img: patient3,
        name: 'Alessia Morin',
        role: 'HR Manager',
        alName: 'أليسيا مورين',
        alRole: 'مدير الموارد البشرية',
        glName: 'Alessia Morin',
        glRole: 'Personalchef',
    },
    {
        img: patient4,
        name: 'Shyla Giles',
        role: 'HR Manager',
        alName: 'شايلا جايلز',
        alRole: 'مدير الموارد البشرية',
        glName: 'Shyla Giles',
        glRole: 'Personalchef',
    },
];
const blogData = [
    {
        img: blog1,
        heading: '5 Reasons Your Children Need Regular Dental CheckUps',
        date: 'March 28, 2021',
        text: "It is very important for the customer to follow the customer's training, but it is the same time as the work",
        alHeading: '5 أسباب تجعل زيارة الأطفال للطبيب الأسنان منتظمة ضرورية',
        glHeading: '5 Gründe, warum Ihre Kinder regelmäßige Zahnarztuntersuchungen benötigen',
        alDate: '28 مارس 2021',
        glDate: '28. März 2021',
        alText: "من المهم جدًا للعميل أن يتبع تدريب العميل، ولكنه في نفس الوقت مثل العمل",
        glText: "Es ist sehr wichtig, dass der Kunde das Training des Kunden befolgt, aber es ist gleichzeitig wie die Arbeit"
    },
    {
        img: blog2,
        heading: 'Everything You Need To Know About a Dead Tooth',
        date: 'March 28, 2021',
        text: "It is very important for the customer to follow the customer's training, but it is the same time as the work",
        alHeading: 'كل ما تحتاج إلى معرفته عن السن الميت',
        glHeading: 'Alles, was Sie über einen toten Zahn wissen müssen',
        alDate: '28 مارس 2021',
        glDate: '28. März 2021',
        alText: "من المهم جدًا للعميل أن يتبع تدريب العميل، ولكنه في نفس الوقت مثل العمل",
        glText: "Es ist sehr wichtig, dass der Kunde das Training des Kunden befolgt, aber es ist gleichzeitig wie die Arbeit"
    },
    {
        img: blog3,
        heading: 'Everything You Want To Know About Cosmetic Dentistry',
        date: 'March 28, 2021',
        text: "It is very important for the customer to follow the customer's training, but it is the same time as the work",
        alHeading: 'كل ما تريد معرفته عن طب الأسنان التجميلي',
        glHeading: 'Alles, was Sie über kosmetische Zahnmedizin wissen möchten',
        alDate: '28 مارس 2021',
        glDate: '28. März 2021',
        alText: "من المهم جدًا للعميل أن يتبع تدريب العميل، ولكنه في نفس الوقت مثل العمل",
        glText: "Es ist sehr wichtig, dass der Kunde das Training des Kunden befolgt, aber es ist gleichzeitig wie die Arbeit"
    },
    {
        img: blog4,
        heading: 'What You Need to Know About Wisdom Teeth',
        date: 'March 27, 2021',
        text: "It is very important for the customer to follow the customer's training, but it is the same time as the work",
        alHeading: 'ما تحتاج إلى معرفته عن أسنان الحكمة',
        glHeading: 'Was Sie über Weisheitszähne wissen müssen',
        alDate: '27 مارس 2021',
        glDate: '27. März 2021',
        alText: "من المهم جدًا للعميل أن يتبع تدريب العميل، ولكنه في نفس الوقت مثل العمل",
        glText: "Es ist sehr wichtig, dass der Kunde das Training des Kunden befolgt, aber es ist gleichzeitig wie die Arbeit"
    },
];

const approachData = [
    {
        sNo: '01',
        title: 'Make an Appointment',
        alTitle: 'إحجز موعد',
        glTitle: 'Einen Termin machen',
        text: 'The pain itself is very important, therefore, the development of the patient, but it also occurs at the same time as labor and pain',
        glText: 'Der Schmerz selbst ist daher für die Entwicklung des Patienten sehr wichtig, er tritt aber auch gleichzeitig mit Wehen und Schmerzen auf',
        alText: 'الألم نفسه مهم جدًا، وبالتالي نمو المريض، ولكنه يحدث أيضًا في نفس وقت المخاض والألم',
    },
    {
        sNo: '02',
        title: 'Meet The Dentist',
        alTitle: 'تعرف على طبيب الأسنان',
        glTitle: 'Lernen Sie den Zahnarzt kennen',
        text: 'The pain itself is very important, therefore, the development of the patient, but it also occurs at the same time as labor and pain',
        glText: 'Der Schmerz selbst ist daher für die Entwicklung des Patienten sehr wichtig, er tritt aber auch gleichzeitig mit Wehen und Schmerzen auf',
        alText: 'الألم نفسه مهم جدًا، وبالتالي نمو المريض، ولكنه يحدث أيضًا في نفس وقت المخاض والألم',
    },
    {
        sNo: '03',
        title: 'General Dental Check Up',
        alTitle: 'فحص الأسنان العام',
        glTitle: 'Allgemeine zahnärztliche Untersuchung',
        text: 'The pain itself is very important, therefore, the development of the patient, but it also occurs at the same time as labor and pain',
        glText: 'Der Schmerz selbst ist daher für die Entwicklung des Patienten sehr wichtig, er tritt aber auch gleichzeitig mit Wehen und Schmerzen auf',
        alText: 'الألم نفسه مهم جدًا، وبالتالي نمو المريض، ولكنه يحدث أيضًا في نفس وقت المخاض والألم',
    },
    {
        sNo: '04',
        title: 'Prescribe & Payment',
        alTitle: 'الوصفة والدفع',
        glTitle: 'Verschreiben und bezahlen',
        text: 'The pain itself is very important, therefore, the development of the patient, but it also occurs at the same time as labor and pain',
        glText: 'Der Schmerz selbst ist daher für die Entwicklung des Patienten sehr wichtig, er tritt aber auch gleichzeitig mit Wehen und Schmerzen auf',
        alText: 'الألم نفسه مهم جدًا، وبالتالي نمو المريض، ولكنه يحدث أيضًا في نفس وقت المخاض والألم',
    }
]
const appointmentDayData = [
    {
        day: 'Monday - Thursday',
        alDay: 'الاثنين -الخميس',
        glDay: 'Montag Donnerstag',
        time: '08.00 AM - 8.00 PM'
    },
    {
        day: 'Friday',
        alDay: 'جمعة',
        glDay: 'Freitag',
        time: '08.00 AM - 5.00 PM'
    },
    {
        day: 'Saturday',
        alDay: 'السبت',
        glDay: 'Samstag',
        time: '09.00 AM - 4.00 PM'
    },
    {
        day: 'Sunday',
        alDay: 'الأحد',
        glDay: 'Sonntag',
        time: '09.00 AM - 6.00 PM'
    },
]
const serviceFaqs = [
    {
        question: 'Where Can I Find More Information?',
        answer: "It's important to have a good customer service, a customer service provider. Aenean's good fortune needs pain. Jasmine mass. Together with their companions, the mountains will give birth to the mighty and the mighty",
        glQuestion: 'Wo finde ich weitere Informationen?',
        alQuestion: 'أين يمكنني العثور على مزيد من المعلومات؟',
        glAnswer: 'Es ist wichtig, einen guten Kundenservice, einen Kundendienstanbieter zu haben. Aeneans Glück braucht Schmerz. Jasminmasse. Zusammen mit ihren Gefährten werden die Berge die Mächtigen und Mächtigen gebären',
        alAnswer: "من المهم أن يكون لديك خدمة عملاء جيدة، ومزود خدمة عملاء. إن حظ أينيان الجيد يحتاج إلى الألم. كتلة الياسمين. سوف تلد الجبال مع رفاقها الأقوياء والأقوياء",
    },
    {
        question: 'What Kinds Of Payment Do You Accept?',
        answer: "It's important to have a good customer service, a customer service provider. Aenean's good fortune needs pain. Jasmine mass. Together with their companions, the mountains will give birth to the mighty and the mighty",
        glQuestion: 'Welche Zahlungsarten akzeptieren Sie?',
        alQuestion: 'ما هي أنواع الدفع التي تقبلونها؟',
        glAnswer: 'Es ist wichtig, einen guten Kundenservice, einen Kundendienstanbieter zu haben. Aeneans Glück braucht Schmerz. Jasminmasse. Zusammen mit ihren Gefährten werden die Berge die Mächtigen und Mächtigen gebären',
        alAnswer: "من المهم أن يكون لديك خدمة عملاء جيدة، ومزود خدمة عملاء. إن حظ أينيان الجيد يحتاج إلى الألم. كتلة الياسمين. سوف تلد الجبال مع رفاقها الأقوياء والأقوياء",
    },
    {
        question: 'What Are Your Terms And Condition?',
        answer: "It's important to have a good customer service, a customer service provider. Aenean's good fortune needs pain. Jasmine mass. Together with their companions, the mountains will give birth to the mighty and the mighty",
        glQuestion: 'Wie lauten Ihre Geschäftsbedingungen?',
        alQuestion: 'ما هي الشروط والأحكام الخاصة بك؟',
        glAnswer: 'Es ist wichtig, einen guten Kundenservice, einen Kundendienstanbieter zu haben. Aeneans Glück braucht Schmerz. Jasminmasse. Zusammen mit ihren Gefährten werden die Berge die Mächtigen und Mächtigen gebären',
        alAnswer: "من المهم أن يكون لديك خدمة عملاء جيدة، ومزود خدمة عملاء. إن حظ أينيان الجيد يحتاج إلى الألم. كتلة الياسمين. سوف تلد الجبال مع رفاقها الأقوياء والأقوياء",
    }
];
const doctorData = [
    {
        img: doctor1,
        name: 'Maya Navarro',
        alName: 'مايا نافارو',
        glName: 'Maya Navarro',
        role: 'Orthodontist',
        alRole: 'أخصائية تقويم الأسنان',
        glRole: 'Kieferorthopädin'
    },
    {
        img: doctor2,
        name: 'Roseanna Sykes',
        alName: 'روزانا سايكس',
        glName: 'Roseanna Sykes',
        role: 'Dentist',
        alRole: 'طبيب أسنان',
        glRole: 'Zahnarzt'
    },
    {
        img: doctor3,
        name: 'Luisa Haworth',
        alName: 'لويزا هاورث',
        glName: 'Luisa Haworth',
        role: 'Dentist',
        alRole: 'طبيب أسنان',
        glRole: 'Zahnarzt'
    },
    {
        img: doctor4,
        name: 'Vanesa Walters',
        alName: 'فانيسا والترز',
        glName: 'Vanesa Walters',
        role: 'Orthodontist',
        alRole: 'أخصائية تقويم الأسنان',
        glRole: 'Kieferorthopädin'
    },
    {
        img: doctor5,
        name: 'Flora Frame',
        alName: 'فلورا فريم',
        glName: 'Flora Frame',
        role: 'Dentist',
        alRole: 'طبيب أسنان',
        glRole: 'Zahnarzt'
    },
    {
        img: doctor6,
        name: 'Miguel Crane',
        alName: 'ميغيل كرين',
        glName: 'Miguel Crane',
        role: 'Senior Dentist',
        alRole: 'طبيب أسنان كبير',
        glRole: 'Leitender Zahnarzt'
    },
];

export {
    menuItems,
    appointmentData,
    homeAboutData,
    homeExperienceData,
    serviceCardData,
    patientFeedBackData,
    blogData,
    approachData,
    appointmentDayData,
    serviceFaqs,
    doctorData
}